import React from "react";
import Layout from "../../reusables/layout/layout";
import Login from "../../Component/loginform/login";
import Requisition from "../../Component/requisitionforms/requisition_bece_cas";

const PaymentLoginBece = () => {
  // const navigate = useNavigate();
  // const [password, setPassword] = useState('');
  // const [loading, setLoading] = useState(false);
  // const [rememberMe, setRememberMe] = useState(false);
  // const [username, setUsername] = useState('');

  // const dispatch = useDispatch();

  return (
    <>
      <div>
        <Layout>
          <Login
            examType={"TEDAC EXAMINATION"}
            url={"/auth/tedac/signin/"}
            navigateTo={"/requisition/tedac"}
            homeLink={"https://tedac.examsboard.lagosstate.gov.ng/"}
          />
        </Layout>
      </div>
    </>
  );
};

export default PaymentLoginBece;
